module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"verifyEmail":"Verify your e-mail address","emailNotRecieved":"E-mail not received","resend":"Resend","verificationEmailSent":"Verification e-mail was sent"}}')
  delete Component.options._Ctor
}
